import { ConfigProvider } from "antd"

ConfigProvider.config({
    theme: {
        primaryColor: "#1A56A5"
    }
})